import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Auth } from "../models/auth";
import { environment } from "src/environments/environment.prod";
import { jwtDecode } from "jwt-decode";
import { TokenStorageService } from "./token-storage.service";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: "root",
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private tokenStorage: TokenStorageService
  ) {}

  //LOGIN
  public login(user: any): Observable<Auth> {
    return this.http.post<Auth>(
      `${environment.baseUrl}/api/v1/auth/authenticate`,
      user,
      httpOptions
    );
  }

// TOKEN
  getToken(): string | null {
    return this.tokenStorage.getToken();
  }

  isTokenExpired(): boolean {
    const token = this.getToken();

    if (!token) return true;

    try {
      const decoded: any = jwtDecode(token);

      // exp is in seconds → convert to milliseconds
      return Date.now() >= decoded.exp * 1000;
    } catch (error) {
      return true;
    }
  }

  logout(): void {
    this.tokenStorage.signOut();
  }

  // OTHER METHODS
  public register(user: any): Observable<{ message: string }> {
    const registerUrl = `${environment.baseUrl}/p2p/auth/signup`;
    return this.http.post<{ message: string }>(registerUrl, user);
  }

  onboardUser(user: any): Observable<{ message: string }> {
    const onboardUserUrl = `${environment.baseUrl}/p2p/otherusers/signup`;
    return this.http.post<{ message: string }>(onboardUserUrl, user);
  }

  resetPassword(params: any): Observable<{ message: string }> {
    const resetPasswordUrl = `${environment.baseUrl}/p2p/reset/change-password`;
    return this.http.post<{ message: string }>(resetPasswordUrl, params);
  }

  forgotPassword(params: any): Observable<{ message: string }> {
    const resetPasswordUrl = `${environment.baseUrl}/p2p/reset/send-token`;
    return this.http.post<{ message: string }>(resetPasswordUrl, params);
  }
}
